import { render, staticRenderFns } from "./QuestionTypeTextImage.vue?vue&type=template&id=3221a1c4"
import script from "./QuestionTypeTextImage.vue?vue&type=script&lang=js"
export * from "./QuestionTypeTextImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports